// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1LW_h","disabled":"styles_disabled__1RBqh"};